export default __webpack_public_path__ + "static/media/27_2_4.ca7d7a8c.png";